import { getBillingDisplayMessage, parseBillingFromChatStatusPayload } from '@/entities/billing';

export const CHAT_BILLING_BLOCKED_TEXT = 'Нет доступа к чату: закончились лимиты.';

export type ChatBillingStatusEvent =
  | { kind: 'blocked'; text: string }
  | { kind: 'warning'; text: string }
  | { kind: 'none' };

const BLOCKING_REASON_CODES = new Set(['quota_exhausted', 'limit_reached', 'billing_blocked']);

const hasBlockingReasonCode = (reasonCode: string | null | undefined): boolean => {
  if (typeof reasonCode !== 'string') {
    return false;
  }

  return BLOCKING_REASON_CODES.has(reasonCode.toLowerCase());
};

export const mapBillingStatusToChatEvent = (payload: unknown): ChatBillingStatusEvent => {
  const parsed = parseBillingFromChatStatusPayload(payload);
  if (!parsed) {
    return { kind: 'none' };
  }

  const billing = parsed.billing;
  const blocked =
    billing?.allowed === false ||
    billing?.error_type === 'billing' ||
    hasBlockingReasonCode(billing?.reason_code);

  if (blocked) {
    return {
      kind: 'blocked',
      text: CHAT_BILLING_BLOCKED_TEXT,
    };
  }

  const warningText = parsed.message ?? getBillingDisplayMessage(billing);

  if (warningText) {
    return {
      kind: 'warning',
      text: warningText,
    };
  }

  return { kind: 'none' };
};
